import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';

// Components
import Heading from '../../../Heading';

// Icons
import GiftIcon from '../../../../icons/gift.svg';
import RemoveIcon from '../../../../icons/close.svg';

// Styles
import styles from './AddedSauce.styl';

const cx = classNames.bind(styles);

export default function AddedSauce(props) {
  const { className, editable, onRemove, sauce } = props;
  const { id, name, isInStopList } = sauce;

  const intl = useIntl();

  const handleRemove = () => {
    onRemove(id);
  };

  return (
    <div className={cx('AddedSauce', className, { AddedSauce_outOfStock: isInStopList })}>
      <Heading className={cx('AddedSauce__text')} level={5}>
        {isInStopList
          ? intl.formatMessage({ id: 'freesauce.outOfStock' })
          : `+ ${intl.formatMessage({ id: 'sauce' })} ${name}`}
      </Heading>
      {!isInStopList && <GiftIcon className={cx('AddedSauce__gift')} />}
      {editable && (
        <button className={cx('AddedSauce__remove')} onClick={handleRemove} type="button">
          {isInStopList ? intl.formatMessage({ id: 'button.replace' }) : <RemoveIcon />}
        </button>
      )}
    </div>
  );
}

AddedSauce.defaultProps = {
  className: '',
  editable: true,
};

AddedSauce.propTypes = {
  className: PropTypes.string,
  editable: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  sauce: PropTypes.object.isRequired,
};
